import { render, staticRenderFns } from "./ModalHistoricoSenado.vue?vue&type=template&id=2f5c5eb4"
import script from "./ModalHistoricoSenado.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoSenado.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoSenado.vue?vue&type=style&index=0&id=2f5c5eb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports